<!-- <header>
  <nav class="navbar navbar-expand-md navbar-dark bg-primary fixed-top">
    <div class="container-fluid">
      <a class="navbar-brand ms-2 CroissantOne" href="#">Provisioning</a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse"
        aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <div class="w-100 d-flex align-items-center justify-content-end">
          <it-dropdown>
            <span button class="text-white">
              <it-icon name="user" size="sm" color="white" class="me-2"></it-icon>
              {{user?.nome}} {{user?.cognome}}</span>
            <ng-container list>
              <it-dropdown-item>
                <a href="/">Esci</a>
              </it-dropdown-item>
            </ng-container>
          </it-dropdown>
        </div>
      </div>
    </div>
  </nav>
</header> -->
<it-header
  slimTitle="Invitalia"
  slimTitleLink="https://www.invitalia.it/"
  showSearch="false">
  <ng-container slimRightZone>
    <it-dropdown class="custom-dropdown">
      <span button class="text-white btn btn-icon">
        <it-icon name="user" size="sm" color="primary" class="rounded-icon me-2"></it-icon>
        {{user?.nome}} {{user?.cognome}}</span>
      <ng-container list>
        <it-dropdown-item>
          <a (click)="logout()" href="/" onclick="return false;">Esci</a>
        </it-dropdown-item>
      </ng-container>
    </it-dropdown>
  </ng-container>
  <ng-container brand>
    <a href="/">
      <img src="assets/img/logo_invitalia_bianco.svg" class="d-block img-fluid logo me-4" alt="Invitalia" loading="lazy">
      <div class="it-brand-text">
        <div class="it-brand-title">Portale Provisioning</div>
        <!-- <div class="it-brand-tagline d-none d-md-block">Tag line dell'Istituzione</div> -->
      </div>
    </a>
  </ng-container>

</it-header>
